module.exports = __webpack_public_path__ + "static/media/long-arrow-up.11f69402.svg";